import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import clsx from 'clsx';
import React from 'react';
import { CaseContext } from '@/context/CaseContext';

interface SaveStatusProps {
	isSaving?: boolean;
	isError?: boolean;
	onTryAgain?: () => void;
}

export const SaveStatus: React.FC<SaveStatusProps> = ({
	isSaving: isSavingProp,
	isError: isErrorProp,
	onTryAgain: onTryAgainProp,
}) => {
	const { saveStatus } = React.useContext(CaseContext);

	const isSaving = isSavingProp ?? saveStatus.isSaving;
	const isError = isErrorProp ?? saveStatus.isError;
	const onTryAgain = onTryAgainProp;

	return (
		<div className="flex items-center gap-[10px]">
			<Icon
				src={
					isSaving
						? Icons.refresh2
						: isError
						? Icons.closeCircleRed
						: Icons.checkCircle
				}
				className={clsx('!size-6', {
					'animate-spin': isSaving,
				})}
			/>
			<Typography type="regular-16">
				{isSaving ? (
					'Saving...'
				) : isError ? (
					<span>
						Could not save.{' '}
						<button
							type="button"
							className="text-primary underline"
							onClick={onTryAgain}
						>
							Retry here.
						</button>
					</span>
				) : (
					'Saved'
				)}
			</Typography>
		</div>
	);
};
